'use client';
import styles from '@/app/ui/components/pagination/pagination.module.scss';
import React from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import Link from 'next/link';
import Image from 'next/image';
export function PaginationArrow(props: { direction: 'left' | 'right'; isDisabled: boolean; currentPage: number }) {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const createPageURL = (pageNumber: number | string) => {
    const params = new URLSearchParams(searchParams ?? '');
    params.set('page', pageNumber.toString());
    return `${pathname}?${params.toString()}`;
  };

  const nextPage = props.direction === 'right' ? props.currentPage + 1 : props.currentPage - 1;

  if (!props.isDisabled) return null;
  return (
    <Link href={createPageURL(nextPage)} className="text-decoration-none">
      <li className={styles.paginationItem}>
        <Image height={14} width={8} alt="" src={`/intstatic/icons/black-arrow-${props.direction}.svg`} />
      </li>
    </Link>
  );
}
